import { MetadataService } from '../../../../BaseFramework/core/http/metadata.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { IntimationService } from '../../../../BaseFramework/core/http/intimation.service';
import * as moment from 'moment/moment';
import { from } from 'rxjs';
import {
  InteractService, ApiRequestService, UserInfoService, AppMetadataHandler, CommonUtilty
} from 'app'
import { default as configData } from './search-OCRintimation.component.json';
import { ChangeDetectorRef } from '@angular/core';
import { default as COLORS } from "configs/color-schemes.json";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from 'app';
import { NzMessageService } from 'ng-zorro-antd/message';

class detail{
  name :string;
  type : string;
  value : number;
}
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}
class TableMetaDataDO {
  key: any;
  header: any;
  pipe: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
  isVisible: Boolean;
  sortOrder: number
}

@Component({
  selector: 'search-OCRintimation',
  templateUrl: './search-OCRintimation.component.html',
  styleUrls: ['./search-OCRintimation.component.scss']
})
export class SearchOCRIntimationComponent implements OnInit {
  public searchResultList = []
  public CRITERIALOOKUP = [];
  public observationDataSet = [];
  public dataSet = [];
  public originalDataSet = [];
  public intimationType = null
  public viewType = null
  public intimationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }
  transactionConfigData: any = this.appMetadataHandler.configDataJSON;
  transactionState = "OCRintimation";
  constructor(private router: Router,
    private intimationService: IntimationService,
    private metadataService: MetadataService,
    private interactService: InteractService,
    private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService,
    public appMetadataHandler: AppMetadataHandler,
    private activatedRoute: ActivatedRoute,
    private commonUtilty: CommonUtilty,
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private appConfig : AppConfig,
    private msg: NzMessageService
    ) {
    console.log("configData ", configData);
    this.configData = configData;
  }
  totalCases : number = 0;
  enableDashboard : boolean = true;
  ngOnInit() {
    this.totalCases = this.response['total_cases_done']
    this.fetchIDPCardData();
    //  this.dashboardItemsList = this.updateCounts(this.response, this.ISPDashboardData);
     console.log("dashboard items updated count = ",this.dashboardItemsList)
    //  this.isLoading = false
    
    setTimeout(() => {
      this.transformData();
    }, 3000);

    this.activatedRoute.data.subscribe(data => {
      this.intimationType = data.intimationType
      this.viewType = data.viewType
      this.getOCRIntimationSearchCriteriaList();
      this.getObservationSearchCriteriaList();
      this.getLatestFiveIntimation(); // Will take latest five  intimations
    });
    if(this.appMetadataHandler.featureFlags.BSLI_Config)
      this.getRoleCd()
  
  console.log("configData ", configData);
  this.configData = configData;
}
user: any = [];
userRoleDOList: any = [];
userRole = null;
getRoleCd(){
  let userRoleDO = this.userInfoService.getUserRoleDO();
  if(userRoleDO.roleId == "CALL_CENTER")
    this.userRole = userRoleDO.roleId

  // if(user.userRoleDOList && this.commonUtilty.isArrayIterable(user.userRoleDOList)){
  //   this.user.userRoleDOList.forEach(userId =>{
  //     if(userId.roleId === "CALL_CENTER"){
        
  //     }
      
  //   });
  // }
}


  configData: any;
  NewIntimation(inboxType) {
    this.interactService.sendPolicyListToInsured([]);
    this.interactService.pingPolicyComponentToRefresh.next(false)
    this.interactService.openNewTransaction(configData.IntimationTypeServiceTaskToIntimationSourceCdMapper[this.intimationType], configData.IntimationTypeToIntimationSourceCdMapper[this.intimationType], inboxType)
  }

  fetchSearchResult($event) {
    console.log("123");
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        console.log(this.dataSet)
        if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
          this.intimationZeroState.title = "No Results found"
          this.intimationZeroState.message = "No records available for the selected search criteria."
        }
      }
      else{
        this.dataSet = []
      }
    }
    else{
        this.getLatestFiveIntimation()
    }
  }

  getOCRIntimationSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchIntake')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          jsonResp.forEach(criteria => {
            if(criteria.attributeTypeCd == 'I' || criteria.attributeTypeCd == 'IO'){
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          }
          })
        }
      })
  }

  getObservationSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchIntake')
      .subscribe(jsonResp => {
        if (jsonResp && Array.isArray(jsonResp)) {
          let observationCriteriaList = [];
          jsonResp.forEach(criteria => {
            if (criteria.attributeTypeCd == 'O' || criteria.attributeTypeCd == 'IO') {
              let tableDataDO = new TableMetaDataDO();
              tableDataDO.key = criteria.attributeName;
              tableDataDO.header = criteria.description;
              tableDataDO.pipe = criteria.attributeDataTypeCd;
              tableDataDO.lookupName = criteria.attributeLookupCd;
              // tableDataDO.lookup = criteria.attributeLookupCd;
              tableDataDO.isVisible = true;
              tableDataDO.sortOrder = criteria.sortOrder ? criteria.sortOrder : null;

              // tableDataDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
              observationCriteriaList.push(tableDataDO);
            }
          });
          // this.observationDataSet = observationCriteriaList;
          this.observationDataSet = this.commonUtilty.sortObjectWithNullValues('sortOrder', observationCriteriaList, 'asc');
          console.log('After sorting intimation dataset:');
          this.observationDataSet.forEach(item => {
            console.log(`Sort Order: ${item.sortOrder}, Key: ${item.key}`);
          });
        }
      })
  }
  
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      // dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
      const momentFormat = this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR.replace('dd', 'DD').replace('yyyy', 'YYYY');
      dateString = moment(rawDate).format(momentFormat); 
    }
    else {
      // dateString = 'N/A'
      dateString = '-'
    }
    return dateString
  }
  // fetchURL = "intakeFetchByGuid"
  openTransactionDetails(data,inboxType?) {
    let fetchURL = `intakeFetchByGuid/${data.guid}`
    let transactionDataIO: any = [];
    let pathVariable = []
    pathVariable.push(data.guid)
    this.apiRequestService.getCallWithAPIMapper(fetchURL).subscribe(resp => {
      // this.dataSet = data.results;
      // this.originalDataSet = this.commonUtilty.deepCopy(this.dataSet);
        if (resp && Object.keys(resp).length) {
          transactionDataIO = resp;
          this.interactService.sendIOToOCRTransaction(data.stageCd,transactionDataIO, inboxType)
          this.router.navigate(["/app/claims/intimation/caseWithOCR"], { state: { redirectToURL:'/app/claims/intimation/search', intimationType: this.intimationType },queryParams: {}, replaceUrl: false });
          // this.router.navigate(['/app/claims/intimation/caseWithOCR'], { queryParams: {}, replaceUrl: false });
        }
      });
  }

  itemsPerPage: any = 5;
  currentPage: any = 0;
  searchURL = "intakeSearch"
  getLatestFiveIntimation() {
    var payload = {}
    payload["page"] = this.currentPage;
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem = {}
    criteriaItem["paramName"] = 'criteriaUser'
    criteriaItem["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem)
    this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(data => {
      this.dataSet = data.results;
      this.originalDataSet = this.commonUtilty.deepCopy(this.dataSet);
    });

  }

  sortColumn(config, order) {
    config.sortOrder = order;
    if (config.isDate) {
      this.dataSet = this.commonUtilty.sortDateObject(config.key, this.dataSet, order);
    } else {
      this.dataSet = this.commonUtilty.sortObject(config.key, this.dataSet, order);
    }
    this.changeDetectorRef.detectChanges();
    return this.dataSet;
  }

  filterColumn(config) {
    if (!config.filterQuery) this.dataSet = this.commonUtilty.deepCopy(this.originalDataSet);
    this.dataSet = this.originalDataSet.filter(data => {
      if (config.isDate) {
        // TODO
        return typeof data[config.key] == 'number' && this.getDateString(data[config.key]).toLowerCase().includes(config.filterQuery.toLowerCase())
      } else {
        if(isNaN(config.filterQuery)) {
          return typeof data[config.key] == 'string' && data[config.key].toLowerCase().includes(config.filterQuery.toLowerCase());
        }
        else{
          return typeof data[config.key] == 'string' && data[config.key].toLowerCase().includes(config.filterQuery);
        }
      }
    });
    if (!this.commonUtilty.isArrayIterable(this.dataSet)) {
      this.intimationZeroState.title = "No results found"
      this.intimationZeroState.message = "No records matched with this query."
    }
  }

  clearFilter(config) {
    config.filterQuery = null;
    this.dataSet = this.commonUtilty.deepCopy(this.originalDataSet);
  }

  claimViaOCR(uploadType?) {
    this.interactService.openClaimViaOCR(uploadType, this.intimationType, '/app/claims/intimation/search');
  }

   
  activityPanelOpen = false;
  activityPanel(status,guid?) {
    if(guid){
      this.fetchClaimData(guid);
    }
    this.activityPanelOpen = !!status;
  }

  initialPayloadInEdit;
  fetchClaimData(guid){
    if(guid){
      this.intimationService.getIntimationDataByGuid(guid).
      subscribe(resp => {
        this.initialPayloadInEdit = this.commonUtilty.deepCopy(resp);
      });
    }
  }
  isAtleastOneHeaderIsChecked = false;
  unselectAllHeaders: boolean;
  manageHeaders(data) {
      console.log("manager headers data", JSON.stringify(data));
      let isCheckedList = this.observationDataSet.filter(e=>e.isVisible==true)
      if(isCheckedList && Array.isArray(isCheckedList) && isCheckedList.length && isCheckedList.length >=1) {
          this.isAtleastOneHeaderIsChecked = true;
      }
      else if(isCheckedList.length < 1) this.isAtleastOneHeaderIsChecked = false;
      
  }

  lastCheckboxPendingToBeUnticked() {
    return this.observationDataSet.filter(e => e['isVisible']).length == 1
}

isOneHeaderChecked = false;
unselectAll() {
    this.observationDataSet.forEach(e=>e['isVisible']=false)
    this.observationDataSet[0].isVisible = true;
    this.lastCheckboxPendingToBeUnticked();
}



cardsBgColor1 = ['#647c8a', '#3f51b5', '#2196f3'];
cardsBgColor = ["linear-gradient(-225deg, #625EB1 0%, #1D8FE1 48%, #22E1FF 100%)", "linear-gradient(to right, #f2994a, #f2c94c)", "linear-gradient(-225deg, #50A7C2 0%, #B7F8DB 100%)"];
cardsTextColor = '#ffffff';
iconColor =['#625EB1','#f2994a','#50A7C2'];
dashboardItemsList : any = [];
analyticsData: any =[];
dashboardMoreItemsList = [];
expandPanel : boolean = true;
selectedLOB: any = 'ALL';
selectedStatus = ['ALL','DRAFT','LAUNCHED','WITHDRAWN'];
isLoading : boolean = false;

/* ====================================== */
/* UI COLOR SCHEME SELECTION AND SETTING  */
colorSchemes = COLORS;
colorSchemesNames = COLORS.map(i=>i.name);
colorScheme = {
name: 'horizon',
selectable: true,
group: 'Continuous',
domain: COLORS.find(i=>i.default).scheme,
};
colorSchemeTempModel:any = COLORS.findIndex(i=>i.default);
colorSchemeModelChange() {
let temp = this.colorScheme;
temp['domain'] = this.colorSchemes[this.colorSchemeTempModel].scheme;
this.colorScheme = Object.assign({}, temp);
this.onDashColorChange(900); /* Reload */
}
/* ====================================== */

ngAfterViewInit(): void {
  setTimeout(()=>{ this.widgetReady=true; },800);
}

widgetReady:boolean = false;
onDashColorChange(e=900) {
  this.widgetReady=false;
  setTimeout(()=>{this.widgetReady=true}, e);
}
onDashDataChange(){
  
}

transformData() {
      // this.dashboardItemsList = jsonData.medicalCodes;
      this.dashboardItemsList = this.ISPDashboardData
      // this.analyticsData = jsonData.statusCount;
      console.log("medical codes=",this.dashboardItemsList);
      this.isLoading = false
}
navigateTo(route){
  if(!route) {
    //do nothing
  }
  else this.router.navigate([route])
}
dateRangeForFWAGraph
navigateToDashboard(path){
  this.router.navigate([path]);
}
setDefaultCardDates(){
  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  let oneMonthPreviousDate = new Date();
  oneMonthPreviousDate.setMonth(oneMonthPreviousDate.getMonth() - 1);
  oneMonthPreviousDate.setHours(0, 0, 0, 0);

  let twoMonthPreviousDate = new Date(oneMonthPreviousDate);
  twoMonthPreviousDate.setMonth(twoMonthPreviousDate.getMonth() - 1);
  twoMonthPreviousDate.setHours(0, 0, 0, 0);

  this.dateRangeForFWAGraph = [oneMonthPreviousDate, currentDate];
}
fromDate = '01/01/2024';
toDate = this.commonUtilty.formatDateToDDMMYYYY(new Date);
setDateRange(event){
  this.dateRangeForFWAGraph = event;
  console.log("changed date = ",this.dateRangeForFWAGraph, event);
  if(this.dateRangeForFWAGraph && this.commonUtilty.isArrayIterable(this.dateRangeForFWAGraph ) && this.dateRangeForFWAGraph.length)
  this.fromDate = this.dateRangeForFWAGraph[0] ? this.commonUtilty.formatDateToDDMMYYYY(this.dateRangeForFWAGraph[0]) : null;
  this.toDate = this.dateRangeForFWAGraph[1] ? this.commonUtilty.formatDateToDDMMYYYY(this.dateRangeForFWAGraph[1]) : null;
  console.log("from date = ",this.fromDate);
  console.log("to date = ",this.toDate);
  if(this.fromDate && this.toDate)
    this.fetchIDPCardData()
  else this.msg.warning(`Please select From Date and To Date.`,{nzDuration : 1500})
  // else if(!this.toDate)this.msg.warning(`Please select To Date`,{nzDuration : 1500})
}
ISPDashboardData = [
 {
    "name" : "Classification",
    "type": "CLASSIFICATION",
    "totalCount" : 0,
    "details": [
      {
        "name": "Rectified",
        "type": "cases_rectified_at_classification",
        "value": 0
      },
      {
        "name": "Proceeded",
        "type": "cases_proceeded_from_classification",
        "value": 0
      }
    ]
  },
 {
    "name" : "Interpretation",
    "type": "INTERPRETATION",
    "totalCount" : 0,
    "details": [
      {
        "name": "Accepted",
        "type": "cases_accepted_at_interpretation",
        "value": 0
      },
      {
        "name": "Rectified",
        "type": "cases_rectified_at_interpretation",
        "value": 0
      },
      {
        "name": "Rejected",
        "type": "cases_rejected_at_interpretation",
        "value": 0
      }
    ]
  },
  {
    "name" : "Rejected Cases",
    "type": "rejected_reason_count",
    "totalCount" : 0,
    "details": [
      {
        "name": "Invalid Extraction",
        "type": "INVALID_EXTRACTION",
        "value": 0
      },
      {
        "name": "Misinterpretation of Data",
        "type": "MISINTERPRETATION_OF_DATA",
        "value": 0
      },
      {
        "name": "Data Format Issues",
        "type": "DATA_FORMAT_ISSUES",
        "value": 0
      },
      {
        "name": "Low Confidence Score",
        "type": "LOW_CONFIDENCE_SCORE",
        "value": 0
      },
      {
        "name": "Validation Error",
        "type": "VALIDATION_ERRORS",
        "value": 0
      },
      {
        "name": "Handwriting Issues",
        "type": "HANDWRITING_ISSUES",
        "value": 0
      },
      {
        "name": "Layout Detection Errors",
        "type": "LAYOUT_DETECTION_ERRORS",
        "value": 0
      },
      {
        "name": "Table Extraction Errors",
        "type": "TABLE_EXTRACTION_ERRORS",
        "value": 0
      }
    ]
  },
  {
    "name" : "Canceled Cases",
    "type": "cancelled_reason_count",
    "totalCount" : 0,
    "details": [
      {
        "name": "Invalid Extraction",
        "type": "INVALID_EXTRACTION",
        "value": 0
      },
      {
        "name": "Misinterpretation of Data",
        "type": "MISINTERPRETATION_OF_DATA",
        "value": 0
      },
      {
        "name": "Data Format Issues",
        "type": "DATA_FORMAT_ISSUES",
        "value": 0
      },
      {
        "name": "Low Confidence Score",
        "type": "LOW_CONFIDENCE_SCORE",
        "value": 0
      },
      {
        "name": "Validation Error",
        "type": "VALIDATION_ERRORS",
        "value": 0
      },
      {
        "name": "Handwriting Issues",
        "type": "HANDWRITING_ISSUES",
        "value": 0
      },
      {
        "name": "Layout Detection Errors",
        "type": "LAYOUT_DETECTION_ERRORS",
        "value": 0
      },
      {
        "name": "Table Extraction Errors",
        "type": "TABLE_EXTRACTION_ERRORS",
        "value": 0
      }
    ]
  }
]

response = {
  "cases_rectified_at_classification": 1,
    "cases_proceeded_from_classification": 103,
    "doctype_count": {
        "DEATH_CERTIFICATE": 163,
        "OTHER": 1,
        "DISCHARGE_NOTE": 7,
        "CLAIM_FORM": 165,
        "Not Found": 1
    },
    "total_cases_done": 181,
    "cancelled_cases": 1,
    "cases_accepted_at_interpretation": 12,
    "cases_rectified_at_interpretation": 4,
    "cases_rejected_at_interpretation": 1,
    "downstream_success_count": 17,
    "rejected_reason_count": {
        "k12": 1
    },
    "cancelled_reason_count": {
        "B40": 1
    }
}
chartColorScheme = {
  domain: ['#5fd2a0', '#40a5b3', '#2597fb', '#0ba3d4', '#E44D25', '#00b862', '#7aa3e5', '#a8385d', '#aae3f5']
};
fetchIDPCardData(){
  let request = {
    "product_type":"IDP",
    "module_name":"OCR",
    "business_process":"FWARISKANALYSIS",
    "workflowCd":"LIFEINTIMATION",  // will changed based on LOB
    "source" : "OCR",
    "AUTH_TOKEN": this.apiRequestService.token,
    "from_date": this.fromDate,
    "to_date": this.toDate
  }

  let url =  `https://${this.appConfig.serverHost}/dev-fwa-generic/idp/get_all_metrics`;
  // this.processingOCR = true;
  this.isLoading = true
  const headers = { 'Content-Type': 'application/json' ,'Authorization' : this.apiRequestService.token};
  this.http.post<any>(url, request, { headers }).subscribe(resp => {
    // this.dashboardItemsList = resp
    this.dashboardItemsList = this.updateCounts(resp, this.ISPDashboardData);
    this.isLoading = false;
  }, e => {
    this.dashboardItemsList = this.updateCounts(this.response, this.ISPDashboardData);
    this.isLoading = false;
  })
  // return resp
}

updateCounts(response, json) {
  json.forEach(item => {
    // Update totalCount if the type is directly in the response
    // if (response[item.type] !== undefined) {
    //   item.totalCount = response[item.type];
    // }

    // Update details array if present
    if (item.details && item.details.length > 0) {
      item.details.forEach(detail => {
        if (response[detail.type] !== undefined && !response[item.type]) {
          detail.value = response[detail.type];
          detail['name'] = `${detail['name']} (${detail.value})`;
        }
        else if(response[item.type] !== undefined && response[item.type][detail.type]){
          detail.value = response[item.type][detail.type];
          detail['name'] = `${detail['name']} (${detail.value})`;
        }
        else{
          detail.value = 0;
          detail['name'] = `${detail['name']} (${detail.value})`;
        }
        item.totalCount += detail.value;
      });
    }
     
  });

  return json;
}

expandCard(event){
  // console.log("card " , event);
  if(this.dashboardItemsList && this.commonUtilty.isArrayIterable(this.dashboardItemsList) && this.dashboardItemsList.length)
  this.dashboardItemsList.forEach((data ,index)=>{
    data.isExpanded = !data.isExpanded;
  })
  this.expandPanel = event;
}

colorSchemeForPieChart = {
  //domain: ['#3aa5c8', '#d35433', '#39976b', '#0ba3d4', '#E44D25', '#00b862', '#7aa3e5', '#a8385d', '#aae3f5']
  domain: ['#5fd2a0', '#40a5b3', '#2597fb', '#0ba3d4', '#E44D25', '#00b862', '#7aa3e5', '#a8385d', '#aae3f5']
}
dummyDataforPieChart=[
  {
    'name' : 'Accepted',
    'value' : 4059,
  },
  {
    'name' : 'Rejected',
    'value' : 1230,
  },
  {
    'name' : 'Referred',
    'value' : 2951,
  }
]

}
